<div class="add-customer-feedback">
  <mat-card class="curtains">
    <div class="customer-feedback-header secondary-icon">
      <h5>Customer Feedback</h5>
      <div class="customer-panel">
        <button matIconButton (click)="confirmDeleteCustomerFeedback()">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
    <mat-card-content>
      <form [formGroup]="customerFeedbackForm">
        <div class="three-fields">
          <mat-form-field>
            <mat-label>Date of feedback</mat-label>
            <input
              (keypress)="dateInputHelper.restrictDateInput($event)"
              [matDatepicker]="feedbackDatePicker"
              required
              formControlName="date"
              matInput />
            <mat-datepicker-toggle [for]="feedbackDatePicker" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #feedbackDatePicker></mat-datepicker>
            @if (date.enabled) {
              <mat-hint>Date format DD/MM/YYYY</mat-hint>
            }
            @if (date.hasError('matDatepickerParse')) {
              <mat-error> The date format is <strong>DD/MM/YYYY</strong> </mat-error>
            }
            @if (date.hasError('required') && !date.hasError('matDatepickerParse')) {
              <mat-error> Date of feedback is <strong>required</strong> </mat-error>
            }
          </mat-form-field>
          <div class="feedback-type">
            <label id="radio-group-label" class="body-2">Type of feedback</label>
            <mat-radio-group
              aria-labelledby="radio-group-label"
              formControlName="feedbackType"
              class="radio-group charcoal-radio">
              <mat-radio-button class="body-1" value="POSITIVE">Positive</mat-radio-button>
              <mat-radio-button class="body-1" value="NEGATIVE">Negative</mat-radio-button>
            </mat-radio-group>
          </div>
          <mat-form-field class="inputField">
            <mat-label>Raised by</mat-label>
            <input matInput autocomplete="off" formControlName="raisedBy" maxlength="128" required />
            @if (raisedBy.invalid) {
              <mat-error>Raised by is <strong>required</strong></mat-error>
            }
          </mat-form-field>
        </div>

        <mat-form-field>
          <mat-label>Details</mat-label>
          <textarea
            matInput
            autocomplete="off"
            formControlName="details"
            maxlength="1024"
            cdkTextareaAutosize="true"
            cdkAutosizeMinRows="1"
            required></textarea>
          @if (details.invalid) {
            <mat-error>Details is <strong>required</strong></mat-error>
          }
        </mat-form-field>

        <mat-form-field class="no-validation">
          <mat-label>Action to resolve</mat-label>
          <textarea
            matInput
            autocomplete="off"
            formControlName="actionToResolve"
            maxlength="512"
            cdkTextareaAutosize="true"
            cdkAutosizeMinRows="1"></textarea>
        </mat-form-field>
      </form>
    </mat-card-content>
  </mat-card>
</div>
